var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSale = function SvgSale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.833 5.676c-1.376-1.498-2.194-2.817-2.638-3.66-.48-.912-.638-1.478-.64-1.483L9.412 0l-.51.225c-.06.026-1.472.66-2.263 2.22-.398.783-.477 1.655-.474 2.248a.73.73 0 0 1-.59.713.74.74 0 0 1-.663-.198L3.96 4.27l-.327.445c-.034.046-.835 1.134-.98 1.351A6.3 6.3 0 0 0 1.58 9.642a6.32 6.32 0 0 0 1.917 4.502A6.5 6.5 0 0 0 8.08 16c3.584 0 6.5-2.874 6.5-6.407 0-1.28-.637-2.708-1.747-3.917"
  })));
};
export default SvgSale;